import React, { useEffect, useState } from "react";
import {
  AdminSettingContext,
  useAdminSettingContext,
} from "./settings.context";
import styles from "./../admin.module.css";
import { Form, Spinner } from "react-bootstrap";
import { useSettingData } from "@/services/admin/settings/get-list-setting.repo";
import { useUpdateSettings } from "@/services/admin/settings/update-setting.repo";
import ScenariosErrorState from "@/components/States/scenariosErrorState";
import ToastComponent from "@/page-components/budgets/components/toast";

const SettingPage = () => {
  const adminContext = useAdminSettingContext();
  const [toast, setToast] = useState(false);
  const [message, setMessage] = useState();
  const [isOn, setIsOn] = useState();
  const [settings, setSettings] = useState([]);

  // const toggleSwitch = () => {
  //   setIsOn(!isOn);
  // };

  const { data, isLoading, error } = useSettingData();

  const settingList = data?.data?.settings;

  const {
    mutate: updateSetting,
    isLoading: updating,
    isSuccess: updateSuccess,
    error: updateError,
  } = useUpdateSettings();

  useEffect(() => {
    if (Array.isArray(settingList) && settingList.length > 0) {
      // Convert active to boolean for UI
      const mappedSettings = settingList.map((item) => ({
        ...item,
        isOn: item.active === 1,
      }));
      setSettings(mappedSettings);
    }
  }, [settingList]);

  // Toggle a specific setting
  const toggleSwitch = (id) => {
    setSettings((prev) =>
      prev.map((setting) =>
        setting.id === id ? { ...setting, isOn: !setting.isOn } : setting
      )
    );

    const updatedSetting = settings.find((s) => s.id === id);
    if (updatedSetting) {
      const newValue = updatedSetting.isOn ? 0 : 1;

      console.log("Payload to send:", [
        {
          id: updatedSetting.id,
          name: updatedSetting.name,
          active: newValue,
        },
      ]);

      updateSetting(
        {
          id: updatedSetting.id,
          name: updatedSetting.name,
          active: newValue,
        },

        {
          onError: () => {
            setSettings((prev) =>
              prev.map((setting) =>
                setting.id === id
                  ? { ...setting, isOn: updatedSetting.isOn }
                  : setting
              )
            );
          },
        }
      );
    }
  };
  useEffect(() => {
    if (updateSuccess) {
      setMessage({
        message: "Settings updated successfully.",
        type: "success",
      });
      setToast(true);
    }
  }, [updateSuccess]);

  useEffect(() => {
    if (updateError) {
      setMessage({
        message: "Unable to update settings. Please try again.",
        type: "Anomaly",
      });
      setToast(true);
    }
  }, [updateError]);

  return (
    <AdminSettingContext.Provider
      value={{
        ...adminContext,
      }}
    >
      {toast && (
        <ToastComponent
          message={message}
          toast={toast}
          setToast={setToast}
          timeout={5000}
        />
      )}
      <div className={styles.mainRolesContainer}>
        <div className={styles.labelHolder}>
          <span className={styles.manageRoles}>Settings</span>
          <span className={styles.text}>
            Manage feature preferences and configurations.
          </span>
        </div>
        <hr></hr>
        {isLoading && (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              width: "100%",
              height: "100vh",
              paddingBottom: "300px",
            }}
          >
            <Spinner />
          </div>
        )}
        {error && <ScenariosErrorState error={error.message} />}
        {data?.data?.settings &&
          settings.map((setting) => (
            <div key={setting.id} className={styles.setting_box}>
              <div className={styles.labelHolder}>
                {/* <span className={styles.virtual_tag}>Virtual Tag</span> */}
                <span className={styles.virtual_tag}>
                  {setting.name.replace(/_/g, " ")}
                </span>
                <span className={styles.text}>
                  {/* Manage display of virtual tags in tag filters. */}
                  {setting.name === "VIRTUAL TAGS" &&
                    "Manage display of virtual tags in tag filters to control their visibility during filtering."}
                </span>
              </div>
              <Form>
                <label className={styles.custom_toggled}>
                  <input
                    type="checkbox"
                    checked={setting.isOn}
                    onChange={() => toggleSwitch(setting.id)}
                    disabled={isLoading || updating}
                  />
                  <span className={styles.sliders}>
                    {setting.isOn ? "On" : "Off"}
                  </span>
                </label>
              </Form>
            </div>
          ))}
      </div>
    </AdminSettingContext.Provider>
  );
};

export default SettingPage;
